import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Line-by-line masked reveal. Parent drives the in-view trigger (reliable),
// children animate via variants so transformed spans don't break the observer.
export const MaskReveal = ({
  lines = [],
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.12,
  as = "div",
  testId,
}) => {
  const reduce = useReducedMotion();
  const Tag = motion[as] || motion.div;

  const container = {
    hidden: {},
    show: {
      transition: { staggerChildren: reduce ? 0 : stagger, delayChildren: delay },
    },
  };
  const line = {
    hidden: { y: reduce ? 0 : "110%" },
    show: { y: 0, transition: { duration: 1.05, ease: EASE } },
  };

  return (
    <Tag
      className={className}
      data-testid={testId}
      variants={container}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.15 }}
    >
      {lines.map((l, i) => (
        <span
          key={i}
          className="block overflow-hidden"
          style={{ paddingBottom: "0.08em" }}
        >
          <motion.span variants={line} className={`block ${lineClassName}`}>
            {l}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

// Single-line masked reveal. Parent (non-transformed) drives the trigger.
export const MaskLine = ({ children, className = "", delay = 0, testId, amount = 0.35 }) => {
  const reduce = useReducedMotion();
  const container = {
    hidden: {},
    show: { transition: { delayChildren: reduce ? 0 : delay } },
  };
  const item = {
    hidden: { y: reduce ? 0 : "115%" },
    show: { y: 0, transition: { duration: 1.05, ease: EASE } },
  };
  return (
    <motion.div
      className="overflow-hidden"
      style={{ paddingBottom: "0.08em" }}
      variants={container}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount }}
      data-testid={testId}
    >
      <motion.div variants={item} className={className}>
        {children}
      </motion.div>
    </motion.div>
  );
};

// Simple fade + rise reveal for blocks of content.
export const Rise = ({ children, className = "", delay = 0, y = 40, testId }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      data-testid={testId}
      initial={reduce ? { opacity: 1 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 1, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
};
